import LegalLayout, { LegalFooter, legalStyles } from "../layouts/LegalLayout";

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "#f4f7fe",
    fontFamily: "Arial, sans-serif",
  },
  navbar: {
    background: "#fff",
    padding: "14px 32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  navLogo: {
    fontSize: 20,
    fontWeight: 800,
    color: "#4318FF",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  navLink: {
    color: "#374151",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
  },
  navLoginBtn: {
    background: "#4318FF",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "none",
  },
  hero: {
    background: "linear-gradient(135deg, #4318FF, #7551FF)",
    color: "#fff",
    padding: "60px 20px",
    textAlign: "center",
  },
  heroTitle: {
    fontSize: 36,
    fontWeight: 800,
    margin: "0 0 12px 0",
  },
  heroMeta: {
    fontSize: 14,
    opacity: 0.85,
    margin: 0,
  },
  content: {
    maxWidth: 800,
    margin: "0 auto",
    padding: "40px 20px",
  },
  tocCard: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    borderLeft: "4px solid #4318FF",
  },
  tocHeading: {
    fontSize: 15,
    fontWeight: 800,
    color: "#1b2559",
    marginBottom: 12,
    marginTop: 0,
  },
  tocList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "6px 24px",
  },
  tocItem: {
    fontSize: 13,
    color: "#4318FF",
    textDecoration: "none",
    fontWeight: 600,
    lineHeight: 1.8,
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
  },
  sectionHeading: {
    fontSize: 17,
    fontWeight: 800,
    color: "#1b2559",
    marginBottom: 12,
    marginTop: 0,
  },
  bodyText: {
    fontSize: 14,
    color: "#374151",
    lineHeight: 2,
    margin: 0,
  },
  subHeading: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1b2559",
    marginTop: 16,
    marginBottom: 6,
  },
  highlight: {
    background: "#fff3cd",
    border: "1px solid #ffc107",
    borderRadius: 8,
    padding: "12px 16px",
    fontSize: 13,
    color: "#856404",
    lineHeight: 1.7,
    marginTop: 12,
  },
  footer: {
    background: "#1b2559",
    color: "#fff",
    padding: "30px 20px",
    textAlign: "center",
  },
  footerLinks: {
    display: "flex",
    justifyContent: "center",
    gap: 24,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  footerLink: {
    color: "#a0aec0",
    textDecoration: "none",
    fontSize: 13,
  },
  footerText: {
    fontSize: 13,
    color: "#a0aec0",
    margin: "4px 0",
  },
};

const TermsAndConditions = () => {
  return (
    <LegalLayout activePage="terms">
      {/* Hero */}
      <div style={legalStyles.hero}>
        <h1 style={styles.heroTitle}>Terms and Conditions</h1>
        <p style={styles.heroMeta}>Effective Date: 1st January 2025 &nbsp;|&nbsp; Last Updated: 28th March 2026</p>
      </div>

      {/* Content */}
      <div style={styles.content}>

        {/* Important Notice */}
        <div style={{ ...styles.card, borderLeft: "4px solid #4318FF" }}>
          <p style={styles.bodyText}>
            Please read these Terms and Conditions carefully before using the <strong>FraudCheck FDS</strong> platform accessible at <strong>fds.uvars.com</strong>. By registering an account, subscribing to any plan, or using any feature of this platform, you agree to be legally bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use this platform.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 10 }}>
            These Terms constitute a legally binding agreement between you ("User", "Owner", "Subscriber") and <strong>Uvars OPC Private Limited</strong>, operating the FraudCheck FDS platform ("Platform", "We", "Us", "Our"), under the <strong>Indian Contract Act, 1872</strong>.
          </p>
        </div>

        {/* Table of Contents */}
        <div style={styles.tocCard}>
          <p style={styles.tocHeading}>Table of Contents</p>
          <ul style={styles.tocList}>
            {[
              ["#definitions", "1. Definitions"],
              ["#acceptance", "2. Acceptance of Terms"],
              ["#services", "3. Services Description"],
              ["#registration", "4. Account Registration"],
              ["#subscription", "5. Subscription & Payment"],
              ["#obligations", "6. User Obligations"],
              ["#prohibited", "7. Prohibited Activities"],
              ["#ip", "8. Intellectual Property"],
              ["#data", "9. Data & Privacy"],
              ["#disclaimers", "10. Disclaimers"],
              ["#liability", "11. Limitation of Liability"],
              ["#governing", "12. Governing Law & Jurisdiction"],
              ["#amendments", "13. Amendments"],
              ["#contact", "14. Contact"],
            ].map(([href, label]) => (
              <li key={href}><a href={href} style={styles.tocItem}>{label}</a></li>
            ))}
          </ul>
        </div>

        {/* 1. Definitions */}
        <div style={styles.card} id="definitions">
          <h2 style={styles.sectionHeading}>1. Definitions</h2>
          <p style={styles.bodyText}>For the purpose of these Terms and Conditions, the following definitions apply:</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}><strong>"Platform" / "FraudCheck FDS"</strong> refers to the fraud detection software-as-a-service (SaaS) platform accessible at fds.uvars.com and its associated mobile or web applications.</li>
            <li style={{ marginBottom: 8 }}><strong>"User" / "Owner" / "Subscriber"</strong> refers to any individual or business entity that registers an account on the Platform as a self-drive car rental business owner.</li>
            <li style={{ marginBottom: 8 }}><strong>"Fraud Report"</strong> means any information, data, or media submitted by a User to report a fraudulent or problematic customer incident.</li>
            <li style={{ marginBottom: 8 }}><strong>"Subscription Plan"</strong> refers to the paid access tier that grants the User rights to use specific features of the Platform for a defined period.</li>
            <li style={{ marginBottom: 8 }}><strong>"Services"</strong> refers to all features provided by the Platform including fraud reporting, fraud search, notifications, analytics, and related tools.</li>
            <li style={{ marginBottom: 8 }}><strong>"Content"</strong> means any data, text, images, reports, or information submitted to or displayed on the Platform.</li>
            <li style={{ marginBottom: 8 }}><strong>"Personal Data"</strong> has the meaning assigned under the Information Technology Act, 2000 and the IT (SPDI) Rules, 2011.</li>
          </ul>
        </div>

        {/* 2. Acceptance of Terms */}
        <div style={styles.card} id="acceptance">
          <h2 style={styles.sectionHeading}>2. Acceptance of Terms</h2>
          <p style={styles.bodyText}>
            By accessing or using the FraudCheck FDS platform in any manner, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions and our Privacy Policy and Refund Policy, which are incorporated herein by reference.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Your continued use of the Platform following any modification to these Terms constitutes acceptance of the revised Terms. These Terms form a valid and enforceable contract under the <strong>Indian Contract Act, 1872</strong>, and you represent that you have the legal capacity to enter into such a contract (i.e., you are at least 18 years of age and are not barred from contracting under applicable law).
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            By completing the registration process and/or making a subscription payment, you are deemed to have expressly accepted these Terms without any reservation.
          </p>
        </div>

        {/* 3. Services Description */}
        <div style={styles.card} id="services">
          <h2 style={styles.sectionHeading}>3. Services Description</h2>
          <p style={styles.bodyText}>
            FraudCheck FDS is a Software-as-a-Service (SaaS) platform designed specifically for self-drive car rental business owners in India. The Platform provides:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}><strong>Fraud Reporting:</strong> The ability to submit fraud reports about problematic customers including identity details, incident descriptions, and supporting photographs.</li>
            <li style={{ marginBottom: 8 }}><strong>Fraud Search:</strong> The ability to search the platform's database by customer name, phone number, Aadhaar/DL number to identify previously reported fraudsters.</li>
            <li style={{ marginBottom: 8 }}><strong>Dashboard & Analytics:</strong> Visual reports and statistics about fraud trends relevant to your business and region.</li>
            <li style={{ marginBottom: 8 }}><strong>Notifications & Alerts:</strong> Real-time alerts when new fraud reports matching configured criteria are added to the database.</li>
            <li style={{ marginBottom: 8 }}><strong>Owner Profile Management:</strong> Management of your business profile, subscription details, and account settings.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            The Platform is provided on an "as-is" and "as-available" basis. We reserve the right to modify, suspend, or discontinue any feature or service at any time with or without prior notice.
          </p>
        </div>

        {/* 4. Account Registration */}
        <div style={styles.card} id="registration">
          <h2 style={styles.sectionHeading}>4. Account Registration</h2>
          <p style={styles.bodyText}>
            To use the Platform, you must create an account by providing accurate, complete, and current information including your full name, business/company name, email address, phone number, and location details.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>You agree that:</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>All registration information you provide is truthful, accurate, and up-to-date.</li>
            <li style={{ marginBottom: 8 }}>You will maintain the security and confidentiality of your account credentials and are solely responsible for all activities that occur under your account.</li>
            <li style={{ marginBottom: 8 }}>You will promptly notify us at admin.umasankar@gmail.com of any unauthorized use of your account.</li>
            <li style={{ marginBottom: 8 }}>You will not create multiple accounts or share your account with third parties.</li>
            <li style={{ marginBottom: 8 }}>You are a genuine self-drive car rental business owner operating in India.</li>
            <li style={{ marginBottom: 8 }}>You will not use a false identity or impersonate any person or entity.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            We reserve the right to verify your account information at any time and to suspend or terminate accounts that provide false or misleading information. Account approval is at the sole discretion of FraudCheck FDS.
          </p>
        </div>

        {/* 5. Subscription & Payment */}
        <div style={styles.card} id="subscription">
          <h2 style={styles.sectionHeading}>5. Subscription & Payment</h2>
          <p style={styles.bodyText}>
            Access to the full features of FraudCheck FDS requires an active paid subscription. The following terms apply to all subscription plans:
          </p>

          <p style={styles.subHeading}>5.1 Subscription Plans</p>
          <p style={styles.bodyText}>
            FraudCheck FDS offers subscription plans on an annual (yearly) basis. Plan details, pricing, and features are as displayed on the Platform at the time of purchase and may be updated periodically.
          </p>

          <p style={styles.subHeading}>5.2 Payment</p>
          <p style={styles.bodyText}>
            All payments are processed in Indian Rupees (INR). Payment must be completed before access to the subscribed plan's features is granted. All applicable taxes including GST are the responsibility of the subscriber.
          </p>

          <p style={styles.subHeading}>5.3 Activation</p>
          <p style={styles.bodyText}>
            Your subscription becomes active upon successful payment and manual or automated approval by the FraudCheck FDS team. You will receive a confirmation notification upon activation.
          </p>

          <p style={styles.subHeading}>5.4 Renewal</p>
          <p style={styles.bodyText}>
            Subscriptions do not auto-renew. You must manually renew your subscription before expiry to maintain uninterrupted access to the Platform.
          </p>

          <div style={styles.highlight}>
            <strong>Non-Refundable:</strong> All subscription fees are strictly non-refundable once payment has been made and the subscription has been activated. By completing payment, you expressly agree to our Refund Policy. Please review our <a href="/refund-policy" style={{ color: "#856404", fontWeight: 700 }}>Refund Policy</a> before subscribing.
          </div>
        </div>

        {/* 6. User Obligations */}
        <div style={styles.card} id="obligations">
          <h2 style={styles.sectionHeading}>6. User Obligations</h2>
          <p style={styles.bodyText}>As a registered User of FraudCheck FDS, you agree and undertake to:</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>Use the Platform only for its intended purpose of fraud prevention in the self-drive car rental industry.</li>
            <li style={{ marginBottom: 8 }}>Submit fraud reports only for genuine incidents that you have personally experienced in your rental business.</li>
            <li style={{ marginBottom: 8 }}>Ensure that all information in fraud reports is accurate, truthful, and to the best of your knowledge and belief.</li>
            <li style={{ marginBottom: 8 }}>Obtain and handle customer personal information (Aadhaar, DL, phone, etc.) in compliance with applicable Indian law, including the IT Act, 2000.</li>
            <li style={{ marginBottom: 8 }}>Maintain the confidentiality of sensitive information accessed through the Platform and not share it outside legitimate business purposes.</li>
            <li style={{ marginBottom: 8 }}>Comply with all applicable local, state, and national laws and regulations in India while using the Platform.</li>
            <li style={{ marginBottom: 8 }}>Not use the Platform to harass, defame, or target individuals for reasons unrelated to legitimate fraud prevention.</li>
            <li style={{ marginBottom: 8 }}>Promptly update your account information if any details change.</li>
          </ul>
        </div>

        {/* 7. Prohibited Activities */}
        <div style={styles.card} id="prohibited">
          <h2 style={styles.sectionHeading}>7. Prohibited Activities</h2>
          <p style={styles.bodyText}>You must NOT use the FraudCheck FDS platform to:</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>Submit false, fabricated, or malicious fraud reports against innocent individuals for personal vendettas or competitive reasons.</li>
            <li style={{ marginBottom: 8 }}>Attempt to gain unauthorized access to other Users' accounts, data, or any backend systems of the Platform.</li>
            <li style={{ marginBottom: 8 }}>Scrape, crawl, or systematically extract data from the Platform using automated tools or scripts.</li>
            <li style={{ marginBottom: 8 }}>Reverse engineer, decompile, or attempt to extract the source code of the Platform.</li>
            <li style={{ marginBottom: 8 }}>Upload malicious code, viruses, or any harmful content to the Platform.</li>
            <li style={{ marginBottom: 8 }}>Circumvent or attempt to bypass any access controls, subscription restrictions, or security measures.</li>
            <li style={{ marginBottom: 8 }}>Use the Platform's data for commercial resale, data brokerage, or any purpose outside fraud prevention for your own rental business.</li>
            <li style={{ marginBottom: 8 }}>Impersonate any other user, person, or organization.</li>
            <li style={{ marginBottom: 8 }}>Engage in any activity that could harm, disrupt, or overload the Platform's infrastructure.</li>
            <li style={{ marginBottom: 8 }}>Violate any applicable Indian law including the IT Act, 2000 and its amendments.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Violation of these prohibitions may result in immediate account termination and may expose you to civil or criminal liability under applicable Indian law, including but not limited to the <strong>Information Technology Act, 2000 (as amended by the IT (Amendment) Act, 2008)</strong>.
          </p>
        </div>

        {/* 8. Intellectual Property */}
        <div style={styles.card} id="ip">
          <h2 style={styles.sectionHeading}>8. Intellectual Property</h2>
          <p style={styles.bodyText}>
            All intellectual property rights in and to the FraudCheck FDS platform — including but not limited to the software, design, user interface, algorithms, trademarks, logo, brand name, and proprietary methodologies — are owned exclusively by FraudCheck FDS and are protected under applicable Indian and international intellectual property laws.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Nothing in these Terms grants you any ownership rights over the Platform. You are granted a limited, non-exclusive, non-transferable, revocable license to use the Platform solely for the purposes described herein, subject to your compliance with these Terms.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            You retain ownership of the fraud report content that you submit. By submitting content to the Platform, you grant FraudCheck FDS a worldwide, royalty-free, non-exclusive license to use, store, process, and display such content for the purposes of operating the Platform and providing the Services.
          </p>
        </div>

        {/* 9. Data & Privacy */}
        <div style={styles.card} id="data">
          <h2 style={styles.sectionHeading}>9. Data & Privacy</h2>
          <p style={styles.bodyText}>
            Your use of the Platform is also governed by our <a href="/privacy" style={{ color: "#4318FF", fontWeight: 700 }}>Privacy Policy</a>, which is incorporated into these Terms by reference. By using the Platform, you consent to the collection, processing, and storage of your personal data as described in our Privacy Policy.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            We handle all personal data in compliance with the <strong>Information Technology Act, 2000</strong>, the <strong>IT (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011</strong>, and other applicable Indian data protection laws.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            When you submit fraud reports containing third-party personal data (such as customer information), you represent and warrant that you have collected such data lawfully and have a legitimate purpose for reporting it. You accept full responsibility for the accuracy and legality of the data you submit.
          </p>
        </div>

        {/* 10. Disclaimers */}
        <div style={styles.card} id="disclaimers">
          <h2 style={styles.sectionHeading}>10. Disclaimers</h2>
          <p style={styles.bodyText}>
            THE PLATFORM AND SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>Specifically, FraudCheck FDS does not warrant or guarantee:</p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>The accuracy, completeness, or reliability of any fraud report submitted by other users.</li>
            <li style={{ marginBottom: 8 }}>That the Platform will be available uninterrupted, error-free, or free from viruses or other harmful components.</li>
            <li style={{ marginBottom: 8 }}>That search results will identify all fraudulent customers or prevent all fraud incidents.</li>
            <li style={{ marginBottom: 8 }}>That the Platform will meet all your specific business requirements.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            FraudCheck FDS is a reporting and information-sharing tool. Business decisions based on Platform data are made at the User's own risk and sole discretion. We do not accept liability for any business decisions made based on information available on the Platform.
          </p>
        </div>

        {/* 11. Limitation of Liability */}
        <div style={styles.card} id="liability">
          <h2 style={styles.sectionHeading}>11. Limitation of Liability</h2>
          <p style={styles.bodyText}>
            To the maximum extent permitted under applicable Indian law, FraudCheck FDS, its owners, directors, employees, agents, and affiliates shall not be liable for any:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>Indirect, incidental, consequential, special, or punitive damages arising from your use of or inability to use the Platform.</li>
            <li style={{ marginBottom: 8 }}>Loss of profits, revenue, data, goodwill, or business opportunity.</li>
            <li style={{ marginBottom: 8 }}>Damages arising from reliance on fraud reports submitted by other users.</li>
            <li style={{ marginBottom: 8 }}>Damages resulting from unauthorized access to your account due to your own negligence in maintaining account security.</li>
            <li style={{ marginBottom: 8 }}>Temporary or permanent unavailability of the Platform.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Our total aggregate liability to you for any claims arising out of or relating to these Terms or your use of the Platform shall in no event exceed the total subscription fees paid by you in the 12 months preceding the claim.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            This limitation of liability is a fundamental element of the basis of the bargain between you and FraudCheck FDS, as acknowledged under the <strong>Indian Contract Act, 1872 (Sections 73-74)</strong>.
          </p>
        </div>

        {/* 12. Governing Law */}
        <div style={styles.card} id="governing">
          <h2 style={styles.sectionHeading}>12. Governing Law & Jurisdiction</h2>
          <p style={styles.bodyText}>
            These Terms and Conditions shall be governed by and construed in accordance with the <strong>Laws of India</strong>, including but not limited to:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>The Indian Contract Act, 1872</li>
            <li style={{ marginBottom: 8 }}>The Information Technology Act, 2000 and IT (Amendment) Act, 2008</li>
            <li style={{ marginBottom: 8 }}>The Consumer Protection Act, 2019</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Any dispute, claim, or controversy arising out of or in connection with these Terms, including any question regarding their existence, validity, breach, or termination, shall be subject to the exclusive jurisdiction of the competent courts in <strong>Andhra Pradesh / Telangana, India</strong>.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Before initiating any formal legal proceedings, both parties agree to make a good-faith effort to resolve disputes amicably through direct communication. Please contact us at admin.umasankar@gmail.com with any grievances.
          </p>
        </div>

        {/* 13. Amendments */}
        <div style={styles.card} id="amendments">
          <h2 style={styles.sectionHeading}>13. Amendments to These Terms</h2>
          <p style={styles.bodyText}>
            FraudCheck FDS reserves the right to amend, modify, or update these Terms and Conditions at any time. When we make material changes, we will update the "Last Updated" date at the top of this page and may notify registered users via email or in-platform notification.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            Your continued use of the Platform after such modifications constitutes your acceptance of the revised Terms. If you do not agree with the revised Terms, you must stop using the Platform and may request account deletion by contacting us.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            We encourage you to review these Terms periodically to stay informed of any changes.
          </p>
        </div>

        {/* 14. Contact */}
        <div style={styles.card} id="contact">
          <h2 style={styles.sectionHeading}>14. Contact Us</h2>
          <p style={styles.bodyText}>
            For any questions, concerns, or grievances regarding these Terms and Conditions, please contact us:
          </p>
          <div style={{ marginTop: 16 }}>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Platform:</strong> FraudCheck FDS</p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Website:</strong> <a href="https://fds.uvars.com" style={{ color: "#4318FF", fontWeight: 600 }}>fds.uvars.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Email:</strong> <a href="mailto:admin.umasankar@gmail.com" style={{ color: "#4318FF", fontWeight: 600 }}>admin.umasankar@gmail.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Phone:</strong> <a href="tel:7207270218" style={{ color: "#4318FF", fontWeight: 600 }}>7207270218</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 0 }}><strong>Jurisdiction:</strong> Andhra Pradesh / Telangana, India</p>
          </div>
        </div>

      </div>

      <LegalFooter />
    </LegalLayout>
  );
};

export default TermsAndConditions;
